import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import Loading from './loading';

const PublicLayout = ({ isAuthenticated, loading, onLogin }) => {
  if (loading) {
    return <Loading />;
  }

  if (isAuthenticated) {
    return <Navigate to="/VoyagerIndexLookup/search" replace />;
  }

  // Passes the onLogin function to the child route components via context
  return <Outlet context={{ onLogin }} />;
};

export default PublicLayout;